<template>
  <div class="svg__icon">
    <svg>
      <use :href="`#${icon}`" fill="currentColor"></use>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  icon: string;
}>();

const icon = ref(props.icon);
</script>

<style lang="scss" scoped>
.svg__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 32px;
  // height: 32px;
  overflow: hidden;
}
</style>
